(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dsm-nouvelle-collection"] && !Shopify.designMode) return;
  try {
    
  const dsmInitManualCarousels = () => {
    document.querySelectorAll('dsm-new-collection').forEach((section) => {
      if (section.dataset.dsmManualCarouselReady === 'true') return;
      const viewport = section.querySelector('[data-dsm-carousel-viewport]');
      const scrollbar = section.querySelector('[data-dsm-carousel-scrollbar]');
      const thumb = section.querySelector('[data-dsm-carousel-thumb]');
      if (!viewport || !scrollbar || !thumb) return;

      section.dataset.dsmManualCarouselReady = 'true';

      const update = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const visibleRatio = Math.min(1, viewport.clientWidth / Math.max(viewport.scrollWidth, 1));
        const progress = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
        const thumbPercent = Math.max(18, visibleRatio * 100);
        const leftPercent = progress * (100 - thumbPercent);
        thumb.style.width = `${thumbPercent}%`;
        thumb.style.left = `${leftPercent}%`;
        scrollbar.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
      };

      const seek = (clientX) => {
        const rect = scrollbar.getBoundingClientRect();
        const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / Math.max(rect.width, 1)));
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        viewport.scrollTo({ left: ratio * maxScroll, behavior: 'smooth' });
      };

      let dragging = false;
      scrollbar.addEventListener('pointerdown', (event) => {
        dragging = true;
        scrollbar.setPointerCapture?.(event.pointerId);
        seek(event.clientX);
      });
      scrollbar.addEventListener('pointermove', (event) => {
        if (dragging) seek(event.clientX);
      });
      scrollbar.addEventListener('pointerup', () => {
        dragging = false;
      });
      scrollbar.addEventListener('pointercancel', () => {
        dragging = false;
      });
      scrollbar.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const card = viewport.querySelector('.dsm-new-collection__card');
        const step = card ? card.getBoundingClientRect().width + 16 : viewport.clientWidth * 0.8;
        if (event.key === 'Home') viewport.scrollTo({ left: 0, behavior: 'smooth' });
        if (event.key === 'End') viewport.scrollTo({ left: viewport.scrollWidth, behavior: 'smooth' });
        if (event.key === 'ArrowLeft') viewport.scrollBy({ left: -step, behavior: 'smooth' });
        if (event.key === 'ArrowRight') viewport.scrollBy({ left: step, behavior: 'smooth' });
      });

      viewport.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(viewport);
      update();
    });
  };

  const dsmPromotionEndsAt = 1785780000000;
  const dsmThirtyPercentHandles = new Set([
    'chemise-a-rayures-rose-et-blanche-taille-l',
    'haut-paillete-femme-beige',
    'top-blanc-chic-femme',
    'top-noir-chic-femme',
    'robe-noire-elegance-taille-m',
    'robe-fleurie-rose-fonce-taille-m',
    'robe-d-ete-femme-imprime-citron-fluide-taille-m',
    'robe-fleurie-bleue-et-blanche-taille-m',
    'robe-blanche-decolletee-elegante',
    'chemise-courte-oversize-lina-blanc',
    'combinaison-boheme-rouge-taille-unique',
    'combinaison-rayee-violet-vin-taille-unique',
    'haut-paillete-femme-rouge',
    'haut-paillete-femme-bleu-clair',
    'pantalon-palazzo-soleil-jaune',
    'pantalon-en-gaze-de-coton-chocolat'
  ]);
  const dsmJewelryPrefixes = ['bague-', 'boucles-', 'bracelet-', 'collier-', 'lot-de-3-bracelets-'];

  const dsmPromotionForHandle = (handle) => {
    if (dsmJewelryPrefixes.some((prefix) => handle.startsWith(prefix))) return 50;
    if (handle.includes('pantalon-palazzo') || dsmThirtyPercentHandles.has(handle)) return 30;
    return 0;
  };

  const dsmAddPromotionBadge = (target, percent) => {
    if (!target || !percent || target.querySelector(':scope > .dsm-home-promotion-badge')) return;
    target.classList.add('dsm-home-promotion-target');
    const badge = document.createElement('span');
    badge.className = 'dsm-home-promotion-badge';
    badge.textContent = `−${percent}%`;
    badge.setAttribute('aria-label', `Réduction de ${percent} pour cent`);
    target.appendChild(badge);
  };

  const dsmApplyHomePromotions = () => {
    if (Date.now() >= dsmPromotionEndsAt) return;

    document.querySelectorAll('main a[href*="/products/"], #MainContent a[href*="/products/"]').forEach((link) => {
      let handle = '';
      try {
        handle = new URL(link.href).pathname.split('/products/')[1]?.split('/')[0] || '';
      } catch (_error) {
        return;
      }
      const percent = dsmPromotionForHandle(handle);
      if (!percent) return;
      const image = link.querySelector('img');
      if (!image) return;
      if (image.closest('.dsm-palazzo-spotlight__swatch')) return;
      const target = image.closest('.dsm-new-collection__media, .dsm-mood-selector__media') || image.parentElement;
      dsmAddPromotionBadge(target, percent);
    });

    document.querySelectorAll('.dsm-palazzo-spotlight__visual').forEach((visual) => {
      dsmAddPromotionBadge(visual, 30);
    });

    document.querySelectorAll('.collection-bubbles__item[href*="/collections/bijoux"] .collection-bubbles__image-wrap').forEach((bubble) => {
      dsmAddPromotionBadge(bubble, 50);
    });

  };

  dsmApplyHomePromotions();
  dsmInitManualCarousels();
  document.addEventListener('shopify:section:load', dsmApplyHomePromotions);
  document.addEventListener('shopify:section:load', dsmInitManualCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsm-palazzo-product"] && !Shopify.designMode) return;
  try {
    
  const dsmWishlistKey = 'dsm-wishlist-handles';

  const readDsmWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(dsmWishlistKey) || '[]');
    } catch (_error) {
      return [];
    }
  };

  const initializeDsmPalazzo = (root) => {
    if (!root || root.dataset.dsmInitialized === 'true') return;
    root.dataset.dsmInitialized = 'true';

    const mainImage = root.querySelector('.dsm-palazzo__main-image');
    root.querySelectorAll('[data-dsm-thumbnail]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = button.dataset.imageUrl;
        mainImage.srcset = '';
        mainImage.alt = button.dataset.imageAlt;
        root.querySelectorAll('[data-dsm-thumbnail]').forEach((thumbnail) => thumbnail.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });

    const quantity = root.querySelector('[data-dsm-quantity]');
    root.querySelector('[data-dsm-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    root.querySelector('[data-dsm-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });

    let variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-dsm-variants]')?.textContent || '[]');
    } catch (_error) {
      variants = [];
    }

    const variantSelect = root.querySelector('[data-dsm-variant-select]');
    const stock = root.querySelector('[data-dsm-stock]');
    const addButton = root.querySelector('[data-dsm-add]');

    variantSelect?.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === variantSelect.value);
      if (!variant || !stock || !addButton) return;

      if (!variant.available) {
        stock.textContent = stock.dataset.outOfStockLabel;
        addButton.textContent = stock.dataset.outOfStockLabel;
        addButton.disabled = true;
        return;
      }

      if (variant.inventoryManagement && variant.inventoryQuantity > 0) {
        const noun = variant.inventoryQuantity === 1 ? 'article' : 'articles';
        stock.textContent = `${stock.dataset.lowStockLabel}${variant.inventoryQuantity} ${noun} en stock`;
      } else {
        stock.textContent = stock.dataset.inStockLabel;
      }

      addButton.disabled = false;
      addButton.textContent = addButton.dataset.defaultLabel || 'AJOUTER AU PANIER';
    });

    const handle = root.dataset.productHandle;
    const updateWishlist = () => {
      const active = readDsmWishlist().includes(handle);
      root.querySelectorAll('[data-dsm-wishlist]').forEach((button) => {
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    root.querySelectorAll('[data-dsm-wishlist]').forEach((button) => {
      button.addEventListener('click', () => {
        const saved = readDsmWishlist();
        const updated = saved.includes(handle) ? saved.filter((item) => item !== handle) : [...saved, handle];
        try {
          localStorage.setItem(dsmWishlistKey, JSON.stringify(updated));
        } catch (_error) {
          return;
        }
        updateWishlist();
      });
    });

    updateWishlist();
  };

  document.querySelectorAll('[data-dsm-palazzo]').forEach(initializeDsmPalazzo);
  document.addEventListener('shopify:section:load', (event) => {
    initializeDsmPalazzo(event.target.querySelector('[data-dsm-palazzo]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-nouveautes-palazzo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('palazzo-carousel')) {
    class PalazzoCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.scroller = this.querySelector('[data-palazzo-scroller]');
        this.previousButton = this.querySelector('[data-palazzo-previous]');
        this.nextButton = this.querySelector('[data-palazzo-next]');

        if (!this.scroller || !this.previousButton || !this.nextButton) return;

        this.updateButtons = () => {
          const maximumScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
          this.previousButton.disabled = this.scroller.scrollLeft <= 2;
          this.nextButton.disabled = this.scroller.scrollLeft >= maximumScroll - 2;
        };

        this.scrollProducts = (direction) => {
          this.scroller.scrollBy({
            left: direction * Math.max(this.scroller.clientWidth * 0.85, 240),
            behavior: 'smooth',
          });
        };

        this.previousButton.addEventListener('click', () => this.scrollProducts(-1));
        this.nextButton.addEventListener('click', () => this.scrollProducts(1));
        this.scroller.addEventListener('scroll', this.updateButtons, { passive: true });
        window.addEventListener('resize', this.updateButtons);
        requestAnimationFrame(this.updateButtons);
      }
    }

    customElements.define('palazzo-carousel', PalazzoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
